var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Paper, Container, Typography, Grid, Icon } from '../';
export var Notification = forwardRef(function Notification(_a, ref) {
    var content = _a.content, className = _a.className, iconName = _a.iconName, iconColor = _a.iconColor, variant = _a.variant, onClose = _a.onClose, style = _a.style, rest = __rest(_a, ["content", "className", "iconName", "iconColor", "variant", "onClose", "style"]);
    var getIconNameForVariant = function () {
        switch (variant) {
            case 'success':
                return 'check';
            case 'error':
                return 'jogging';
            case 'warning':
                return 'quiet';
            default: {
                return 'info';
            }
        }
    };
    var getIconColorForVariant = function () {
        switch (variant) {
            case 'success':
                return 'green';
            case 'error':
                return 'pink';
            case 'warning':
                return 'orange';
            default: {
                return 'grey';
            }
        }
    };
    var resolvedIconName = iconName !== null && iconName !== void 0 ? iconName : getIconNameForVariant();
    var resolvedIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : getIconColorForVariant();
    return (React.createElement(Paper, __assign({ ref: ref, className: className, style: style }, rest),
        React.createElement(Container, { padded: 'small' },
            React.createElement(Grid, { spacing: 'small', wrap: 'nowrap', justifyContent: 'space-between', alignItems: 'center' },
                React.createElement(Grid.Item, null,
                    React.createElement(Icon, { name: resolvedIconName, color: resolvedIconColor, size: 'medium' })),
                React.createElement(Grid.Item, { style: { flex: 1 } },
                    React.createElement(Typography, { as: 'span', size: 'large', weight: 'medium', align: 'justify' }, content)),
                React.createElement(Grid.Item, null,
                    React.createElement(Icon, { as: 'link', name: 'cross', onClick: onClose, size: 15 }))))));
});
Notification.defaultProps = {
    variant: 'default'
};
Notification.displayName = 'Notification';
export default Notification;
//# sourceMappingURL=Notification.js.map